import React from "react";
import Grid from '@mui/material/Grid2';
import CardProduct from "./component/CardProduct";
import { FaRegStar, FaStar } from "react-icons/fa";
import { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import "./styles/Contenido.css";
import { FaSearch } from "react-icons/fa";
import Select from "react-select";
import $ from "jquery";

const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%", // Ancho completo
      height: "50px", // Altura fija
      background: 'transparent',
      border: '2px solid var(--border-color)',
      borderRadius: '40px',
      padding: '5px',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(255, 255, 255, 0.5)' : 'none',
      fontSize: '16px',
      maxHeight: '70px', // Altura máxima del Select
      overflowY: 'auto', // Permite desplazamiento interno
      color: '#000',
      '&:hover': {
        borderColor: 'var(--border-color)',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#000', // Cambiar el color del texto
    }),
    input: (provided) => ({
      ...provided,
      color: '#000', // Color del texto mientras se escribe
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'var(--text-principal)', // Color del placeholder
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: 'var(--color-selectIcons)',        // color de la flecha
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: 'var(--color-selectIcons)',  
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: 'var(--color-opcionseleccionada)', 
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: 'var(--textButtonHome)',                                  
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '10px',
      overflow: 'hidden',
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isFocused ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
      color: '#000',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.3)',
      },
    }),
    ValueContainer: (provided) => ({
        ...provided,
        maxHeight: '10px', // Limita la altura del contenedor de valores seleccionados
        overflowY: 'auto', // Habilitar desplazamiento dentro del contenedor
    }),
  };

const tematicas = [
    {value: "Programación", label: "Programación"},
    {value: "Programación web", label: "Programación web"},
    {value: "Programación de aplicaciones móviles", label: "Programación de aplicaciones móviles"},
    {value: "Lenguajes de programación", label: "Lenguajes de programación"},
    {value: "Java", label: "Java"},
    {value: "C++", label: "C++"},
    {value: "Python", label: "Python"},
    {value: "JavaScript", label: "JavaScript"},
    {value: "Php", label: "Php"},
    {value: "IA", label: "IA"},
    {value: "Emprendimiento", label: "Emprendimiento"},
    {value: "Comunicación", label: "Comunicación"},
    {value: "Ventas", label: "Ventas"},
    {value: "Negocios", label: "Negocios"},
    {value: "Gestión de Proyectos", label: "Gestión de Proyectos"},
    {value: "Recursos Humanos", label: "Recursos Humanos"},
    {value: "Comercio electrónico", label: "Comercio electrónico"},
    {value: "Contabilidad", label: "Contabilidad"},
    {value: "Finanzas", label: "Finanzas"},
    {value: "Economía", label: "Economía"},
    {value: "Inversión", label: "Inversión"},
    {value: "Informática", label: "Informática"},
    {value: "Ofimática", label: "Ofimática"},
    {value: "Hardware", label: "Hardware"},
    {value: "Desarrollo Personal", label: "Desarrollo Personal"},
    {value: "Diseño", label: "Diseño"},
    {value: "Diseño Gráfico", label: "Diseño Gráfico"},
    {value: "Diseño 3D y animación", label: "Diseño 3D y animación"},
    {value: "Diseño de moda", label: "Diseño de moda"},
    {value: "Diseño arquitectónico", label: "Diseño arquitectónico"},
    {value: "Diseño de interiores", label: "Diseño de interiores"},
    {value: "Marketing", label: "Marketing"},
    {value: "Marketing digital", label: "Marketing digital"},
    {value: "Marca personal", label: "Marca personal"},
    {value: "Arte y manualidades", label: "Arte y manualidades"},
    {value: "Pintura", label: "Pintura"},
    {value: "Dibujo", label: "Dibujo"},
    {value: "Cocina", label: "Cocina"},
    {value: "Fotografía y vídeo", label: "Fotografía y vídeo"},
    {value: "Nutrición", label: "Nutrición"},
    {value: "Deporte y fitness", label: "Deporte y fitness"},
    {value: "Música", label: "Música"},
    {value: "Ingeniería", label: "Ingeniería"},
    {value: "Humanidades", label: "Humanidades"},
    {value: "Filosofía", label: "Filosofía"},
    {value: "Lengua y literatura", label: "Lengua y literatura"},
    {value: "Matemáticas", label: "Matemáticas"},
    {value: "Ciencia", label: "Ciencia"},
    {value: "Física", label: "Física"},
    {value: "Química", label: "Química"},
    {value: "Biología", label: "Biología"},
    {value: "Geología", label: "Geología"},
    {value: "Ciencias Sociales", label: "Ciencias Sociales"},
    {value: "Psicología", label: "Psicología"},
    {value: "Historia", label: "Historia"},
    {value: "Historia del arte", label: "Historia del arte"},
    {value: "Geografía", label: "Geografía"},
    {value: "Idiomas", label: "Idiomas"},
    {value: "Idioma Inglés", label: "Idioma Inglés"},
    {value: "Idioma Español", label: "Idioma Español"},
    {value: "Idioma Francés", label: "Idioma Francés"},
    {value: "Idioma Alemán", label: "Idioma Alemán"},
    {value: "Idioma Ruso", label: "Idioma Ruso"},
    {value: "Idioma Chino", label: "Idioma Chino"},
    {value: "Idioma Árabe", label: "Idioma Árabe"},
    {value: "Idioma Japonés", label: "Idioma Japonés"},
    {value: "Formación de profesorado", label: "Formación de profesorado"},
    {value: "Preparación para examenes oficiales", label: "Preparación para examenes oficiales"},
];


const Contenido = () => {
    useEffect(() => {
        $(".filtros").hide().slideDown(400);

        return () => {
            $(".filtros").stop(true, true).show();
        };
    }, []);


    //Filtros iniciales
    const location = useLocation();
    const { filtro_inicial, tematicas_inicial } = location.state || { filtro_inicial: "todo", tematicas_inicial: null };


    //Obtener productos, la información extra y la ordenación
    const [productos, setProductos] = useState([]);
    const [OrdenSeleccionado, setOrdenSeleccionado] = useState("alfabetico");
    const [productosCompletos, setProductosCompletos] = useState([]);

    //Filtros
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [precioMinimo, setPrecioMinimo] = useState("");
    const [precioMaximo, setPrecioMaximo] = useState("");
    const [valoracionSeleccionada, setValoracionSeleccionada] = useState("todas");

    //Filtrar por tipo de contenido
    const [mostrarCursos, setMostrarCursos] = useState(true);
    const [mostrarClases, setMostrarClases] = useState(true);
    const [mostrarClasesP, setMostrarClasesP] = useState(true);

    //tags de búsqueda por palabras
    const [tags, setTags] = useState([]);
    const [tag, setTag] = useState("");


    //Filtros iniciales
    useEffect(() => {
        //Inicialmente
        setTags([]);
        setSelectedOptions([]);
        setPrecioMinimo("");
        setPrecioMaximo("");
        setValoracionSeleccionada("todas");
        setMostrarCursos(true);
        setMostrarClases(true);
        setMostrarClasesP(true);
        setOrdenSeleccionado("alfabetico");

        if(filtro_inicial === "cursos"){
            setMostrarCursos(true);
            setMostrarClases(false);
            setMostrarClasesP(false);
        }
        else if(filtro_inicial === "clases"){
            setMostrarCursos(false);
            setMostrarClases(true);
            setMostrarClasesP(true);
        }
        else if(filtro_inicial === "tematicas" && tematicas_inicial){
            setSelectedOptions([{ value: tematicas_inicial, label: tematicas_inicial }]);
        }
        else{
            setMostrarCursos(true);
            setMostrarClases(true);
            setMostrarClasesP(true);
        }    
    }, [filtro_inicial, tematicas_inicial]);
    

    //Manejar tags
    const handleTags = (e) => {
        const codigo = e.keyCodigo || e.which;
        const newTag = tag.trim();

        //cuando se presiona enter (código 13) o coma (código 188)
        if((codigo !== 13 && codigo !== 188) || tag.length === 0){
            return;
        }
        if(!tags.includes(newTag)){
            setTags([...tags, newTag])
        }
        setTimeout(() => {
            setTag(""); 
        }, 0);
    } 
    const eliminarTag = (index) => {
        const TagsMod = [...tags];
        TagsMod.splice(index, 1);
        setTags(TagsMod)
    }

    //Manejar Select (multiples opciones)
    const handleSelect = (selectedOption) => {
        setSelectedOptions(selectedOption);
    };

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';


    //Obtener productos (cursos y clases)
    const getProductos = async() => {
        try{
            const [response1, response2] = await Promise.all([
                fetch(`${baseUrl}/api/cursos/`, {
                    method: "GET",
                    headers: {
                    'Content-Type': 'application/json', 
                    },
                }),
                fetch(`${baseUrl}/api/clases/`, {
                    method: "GET",
                    headers: {
                    'Content-Type': 'application/json', 
                    },
                })
            ]);
          
            if (!response1.ok || !response2.ok) {
                throw new Error("cursos o clases no encontrados o error en la respuesta");
            }

            let [cursos, clases] = await Promise.all([response1.json(), response2.json()]);

            const filtrarEliminados = (prod) => {
            return (
                prod.Nombre !== null &&
                prod.Descripcion !== null &&
                prod.Tematica !== null &&
                prod.ImagenPortada !== null &&
                prod.FechaSubida !== null
            );
        };

            cursos = cursos.filter(filtrarEliminados);
            clases = clases.filter(filtrarEliminados);

            const lista_productos = [
                ...cursos.map(curso => ({ ...curso, tipo: 'curso' })), 
                ...clases.map(clase => ({
                    ...clase, tipo: clase.Particular ? 'claseParticular' : 'clase'
                })),
            ];

            //Ordenación inicial (alfabética)
            lista_productos.sort((a,b) => a.Nombre.localeCompare(b.Nombre));

            setProductos(lista_productos);
            
        } catch (error) {
            console.error("Error al obtener los productos" + error.message);
        }
    };
    
    useEffect(() => {
        getProductos();
    }, []);

    //Añadir información sobre valoración y tutor al producto (almacenadas en otra colección)
    useEffect(() => {
        if(productos.length === 0) return;

        const fetchExtraInfo = async () => {
            //Hacemos dos consulta, el tutor que ha creado el contenido y las reseñas de dicho contenido
            const prodCompletos = await Promise.all(
                productos.map(async (prod) => {
                    //Obtener información del tutor
                    let tutor = null;
                    if(prod.Id_Tutor){
                        try {
                            const resTutor = await fetch(
                                `${baseUrl}/api/users/${prod.Id_Tutor}`,
                                {
                                    method: "GET",
                                    headers: { "Content-Type": "application/json" },
                                }
                            );
                            if (resTutor.ok) {
                                tutor = await resTutor.json();
                            }
                        } catch (error) {
                              console.error("Error al obtener tutor: " + error.message);
                        }
                    }

                    //Obtener reseñas y calcular la valoración
                    let rating = 0;
                    try{
                        const resValoracion = await fetch(
                            `${baseUrl}/api/resennas/search/contenido/${prod._id}`,
                            {
                                method: "GET",
                                headers: { "Content-Type": "application/json" }, 
                            }
                        );
                        if(resValoracion.ok){
                            const resennas = await resValoracion.json();
                            const suma = resennas.reduce(
                                (acum, r) => acum + r.Valoracion,
                                0
                            );
                            //Calcular valor medio de reseñas
                            rating = resennas.length > 0 ? suma / resennas.length : 0;
                        }
                    } catch(error){
                        console.error("Error al obtener reseñas: " + error.message);
                    }
                        //Devolver el producto con toda la información extra de tutor y valoracion
                        return { ...prod, tutor, rating };
                    })
                );
                setProductosCompletos(prodCompletos);
        };

        fetchExtraInfo();
    }, [productos]);
    
    //Aplicar filtros
    const productosFiltrados = useMemo(() => {
        return productosCompletos.filter(prod => {
            //Tipo de contenido
            if(prod.tipo === "curso" && !mostrarCursos) return false;
            if(prod.tipo === "clase" && !mostrarClases) return false;
            if(prod.tipo === "claseParticular" && !mostrarClasesP) return false;
        
            //Filtro por búsqueda. Búsqueda Y (Se Muestra si tiene una condición y otra y otra... ), para cambiar a búsqueda tipo or vambiar every por some (tags.some)
            if(tags.length !== 0){
                const coincidenciaTags = tags.every(t => {
                    const coincidenciaNombreProd = prod.Nombre.toLowerCase().includes(t.toLowerCase());
                    const coincidenciaDescripcionProd = prod.Descripcion.toLowerCase().includes(t.toLowerCase()); 
                    const coincidenciaTutorNombre = prod.tutor.Nombre.toLowerCase().includes(t.toLowerCase()) ||
                        prod.tutor.Apellidos.toLowerCase().includes(t.toLowerCase());
                    
                    return coincidenciaNombreProd || coincidenciaDescripcionProd || coincidenciaTutorNombre;
                });

                if(!coincidenciaTags) return false;
            }
    
            //Filtros por temáticas. Funciona como or, para cambiar a and:
            /*
            if (selectedOptions.length > 0) {
                const tematicasSeleccionadas = selectedOptions.map(op => op.value.toLowerCase());
    
                if (!prod.Tematica || !tematicasSeleccionadas.every(tem => prod.Tematica.map(t => t.toLowerCase()).includes(tem))) {
                    return false;
                }
            }           
            */
            if(selectedOptions.length > 0){
                const tematicasSeleccionadas = selectedOptions.map(op => op.value.toLowerCase());
                //Verificar que el producto tenga al menos una temática seleccionada
                if(!prod.Tematica?.some(tem => tematicasSeleccionadas.includes(tem.toLowerCase()))){
                    return false;
                }
            }
        

            //Filtro por precio
            if(precioMinimo !== "" && prod.Precio < Number(precioMinimo)) return false;
            if(precioMaximo !== "" && prod.Precio > Number(precioMaximo)) return false;

            //Filtrar por valoración
            if(valoracionSeleccionada !== "todas"){
                let valorMinimo = 0;
                if(valoracionSeleccionada === "una") valorMinimo = 1;
                if(valoracionSeleccionada === "dos") valorMinimo = 2;
                if(valoracionSeleccionada === "tres") valorMinimo = 3;
                if(valoracionSeleccionada === "cuatro") valorMinimo = 4;
                if(prod.rating < valorMinimo) return false;
            }

            return true;
        });
    }, [
        productosCompletos,
        mostrarCursos,
        mostrarClases,
        mostrarClasesP,
        tags,
        selectedOptions,
        precioMinimo,
        precioMaximo,
        valoracionSeleccionada
    ]);

    //Manejar orden
    const manejarOrdenacion = (tipoOrden) => {
        setOrdenSeleccionado(tipoOrden);
    };

    //Ordenar según estado de ordenSeleccionado
    const ordenarProductos = useMemo(() => {
        const ordenacion = [...productosFiltrados];
        switch(OrdenSeleccionado){
            case "alfabetico":
                ordenacion.sort((a,b) => a.Nombre.localeCompare(b.Nombre));
                break;
            case "reciente":
                ordenacion.sort((a,b) => new Date(b.FechaSubida) - new Date(a.FechaSubida));
                break;
                case "precioAsc":
                    ordenacion.sort((a,b) => a.Precio - b.Precio);
                    break;
                case "precioDesc":
                    ordenacion.sort((a,b) => b.Precio - a.Precio);
                    break;
                case "valoracion":
                    ordenacion.sort((a, b) => b.rating - a.rating);
                    break;
                default:
                    break;
        } 
        return ordenacion;
    }, [productosFiltrados, OrdenSeleccionado]);
    

    return(
        <>
        <div className='principal'> 
            {mostrarCursos && (mostrarClases || mostrarClasesP) && (
                <h1 className="titulo">Cursos y clases</h1>
            )}
            {mostrarCursos && !mostrarClases && !mostrarClasesP && (
                <h1 className="titulo">Cursos</h1>
            )}
            {!mostrarCursos && (mostrarClases || mostrarClasesP) && (
                <h1 className="titulo">Clases</h1>
            )}
            <div className='contenido'>
                <div className='filtros'>
                    <h2>Filtros</h2>
                    <div className="filtrosContent">
                        <h3>Buscar por palabras</h3>
                        <div className="inputWrapper">
                            <FaSearch className="searchIcon" />
                            <input type="text" placeholder="Escribe para buscar..." value={tag} maxLength={50} onChange={(e) => setTag(e.target.value)} onKeyDown={handleTags}/>
                            {tags.length !== 0 && 
                            <div className="ContenedorTag">
                                {tags.map((tag, index) => (
                                    <div className="tag">
                                        <span className="nombreTag">{tag}</span>
                                        <span className="icono" onClick={() => eliminarTag(index)}>
                                            &times;
                                        </span>
                                    </div>
                                ))}
                            </div>
                            }
                        </div> 
                    </div>
                    <div className="filtrosContent">
                        <h3 style={{ marginTop: tags.length !== 0 ? '25px' : '0px' }}>Seleccionar temáticas</h3>
                        <Select 
                            options={tematicas}
                            value={selectedOptions}
                            isMulti={true}
                            styles={customStyles}
                            placeholder="Filtrar por temáticas"
                            onChange={handleSelect}
                        />
                    </div>
                    <div className="filtrosContent">
                        <h3>Filtrar por precio</h3>
                        <div className="precioRow">
                            <label htmlFor="num_min">Precio Mínimo</label>
                            <input type="number" id="num_min" name="num_min" style={{backgroundColor: "white"}} value={precioMinimo} onChange={(e) => setPrecioMinimo(e.target.value)} /> €
                        </div>
                       
                        <div className="precioRow">
                            <label htmlFor="num_max">Precio Máximo</label>
                            <input type="number" id="num_max" name="num_max" style={{backgroundColor: "white"}} value={precioMaximo} onChange={(e) => setPrecioMaximo(e.target.value)} /> €
                        </div>
                    </div>
                    <div className="filtrosContent">
                        <h3>Filtrar por valoración</h3>
                        <div className="item">
                            <input type="radio" id="val0" name="filtrar_val" value="todas" checked={valoracionSeleccionada === "todas"} onChange={(e) => setValoracionSeleccionada(e.target.value)}/>
                            <label htmlFor="val0">Todas las valoraciones</label>
                        </div>

                        <div className="item">
                            <input type="radio" id="val1" name="filtrar_val" value="una" checked={valoracionSeleccionada === "una"} onChange={(e) => setValoracionSeleccionada(e.target.value)}/>
                            <label htmlFor="val1"><FaStar /> <FaRegStar /> <FaRegStar /> <FaRegStar /> <FaRegStar /> o más</label>
                        </div>
                        
                        <div className="item">
                            <input type="radio" id="val2" name="filtrar_val" value="dos" checked={valoracionSeleccionada === "dos"} onChange={(e) => setValoracionSeleccionada(e.target.value)}/>
                            <label htmlFor="val2"><FaStar /> <FaStar /> <FaRegStar /> <FaRegStar /> <FaRegStar /> o más</label>
                        </div>
                        
                        <div className="item">
                            <input type="radio" id="val3" name="filtrar_val" value="tres" checked={valoracionSeleccionada === "tres"} onChange={(e) => setValoracionSeleccionada(e.target.value)}/>
                            <label htmlFor="val3"><FaStar /> <FaStar /> <FaStar /> <FaRegStar /> <FaRegStar /> o más</label>
                        </div>
                        
                        <div className="item">
                            <input type="radio" id="val4" name="filtrar_val" value="cuatro" checked={valoracionSeleccionada === "cuatro"} onChange={(e) => setValoracionSeleccionada(e.target.value)}/>
                            <label htmlFor="val4"><FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaRegStar /> o más</label>
                        </div>
                    </div>
                    <div className="filtrosContent">
                        <div className="item">
                            <label htmlFor="cursosCheck">Mostrar cursos</label>
                            <input type="checkbox" id="cursosCheck" name="contenidoCheck" checked={mostrarCursos} onChange={() => setMostrarCursos(!mostrarCursos)} />
                        </div>
                        
                        <div className="item">
                            <label htmlFor="clasesCheck">Mostrar clases</label>
                            <input type="checkbox" id="clasesCheck" name="contenidoCheck" checked={mostrarClases} onChange={() => setMostrarClases(!mostrarClases)} />
                        </div>
                        
                        <div className="item">
                            <label htmlFor="clasesPCheck">Mostrar clases particulares</label>
                            <input type="checkbox" id="clasesPCheck" name="contenidoCheck" checked={mostrarClasesP} onChange={() => setMostrarClasesP(!mostrarClasesP)} />
                        </div>
                    </div>
                </div>
                <div className='contenedorPrincipal'>
                    <div className='ordenacion'>
                        <button className={`botonOrdenacion ${OrdenSeleccionado === "alfabetico" ? "active" : ""}`} onClick={() => manejarOrdenacion("alfabetico")}>Alfabético</button>
                        <button className={`botonOrdenacion ${OrdenSeleccionado === "reciente" ? "active" : ""}`} onClick={() => manejarOrdenacion("reciente")}>Más recientes</button>
                        <button className={`botonOrdenacion ${OrdenSeleccionado === "precioAsc" ? "active" : ""}`} onClick={() => manejarOrdenacion("precioAsc")}>Precio ascendente</button>
                        <button className={`botonOrdenacion ${OrdenSeleccionado === "precioDesc" ? "active" : ""}`} onClick={() => manejarOrdenacion("precioDesc")}>Precio descendente</button>
                        <button className={`botonOrdenacion ${OrdenSeleccionado === "valoracion" ? "active" : ""}`} onClick={() => manejarOrdenacion("valoracion")}>Mayor valoración</button>
                    </div>
                
                    <Grid container spacing={2}>
                        {ordenarProductos?.map((prod) => (
                            <div key={prod?._id}>
                                <Grid sx={{ flexBasis: { xs: "100%", sm: "50%", md: "33.33%" } }}>
                                    <CardProduct producto={prod}/>
                                </Grid>
                            </div>
                        ))}
                    </Grid>
                </div>
            </div>
        </div>

        
        </>
    );
};

export default Contenido;